function fileUpload(file) {
  const ApiUpload = window.FileMedia
  return new ApiUpload(file)
}

export default fileUpload
